// extracted by mini-css-extract-plugin
export default {"Wrapper":"ShowMoreInfoPopover_Wrapper__Hx9Mf","Content":"ShowMoreInfoPopover_Content__f3Yr6"};